import crud from './_crud'
import { callApi } from 'utils/api'

const loadBranchOfficesByUsertype = ({ userType }) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/branch_office/get_branch_offices_by_usertype`, {
			method: 'GET',
			headers: {
				Authorization: state.app[userType].token,
			},
			params: {
				userType: userType,
				sys_company_id: state.app[userType].sys_company_id,
				[`${userType}_id`]: state.app[userType].id,
			},
		})

		dispatch({
			type: `GET_ALL_BRANCHOFFICES_BY_USERTYPE`,
			payload: res.body,
		})

		return res.body
	}
}

const loadTimeZonesList = () => {
	return async (dispatch, getState)  => {
		const state = getState()

		const res = await callApi(`/utils/time_zones_list`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
		})

		dispatch({
			type: `GET_TIME_ZONES_LIST`,
			payload: res.body,
		})

		return res.body
	}
}

const syncUnits = (data) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/branch_office/sync_units_to_branch_offices`, {
			method: 'POST',
			headers: {
				Authorization: state.app.user.token,
			},
			body: JSON.stringify(data),
		})
		
		return res.body
	}
}

const syncTrailers = (data) => {
	return async (dispatch, getState) => {
		const state = getState()

		const res = await callApi(`/branch_office/sync_trailers_to_branch_offices`, {
			method: 'POST',
			headers: {
				Authorization: state.app.user.token,
			},
			body: JSON.stringify(data),
		})

		return res.body
	}
}

const loadBranchOffices = () => { {
	return async (dispatch, getState) => {
		const state = getState()
		const res = await callApi(`/branch_office/get_all_branch_offices`, {
			method: 'GET',
			headers: {
				Authorization: state.app.user.token,
			},
		})
		dispatch({
			type: `GET_ALL_BRANCHOFFICES`,
			payload: res.body,
		})
		return res.body
	}
}}

const actions = crud('branch_office', 'la sucursal', 'las sucursales')

export default { ...actions, loadBranchOfficesByUsertype, loadTimeZonesList, syncUnits, syncTrailers, loadBranchOffices }